// extracted by mini-css-extract-plugin
export default {"reportedIncome":"wiFbErNw3pZf20l0nYXH","reportedIncomeTitle":"t5Dm0mSGaYmshiEK_1ag","link":"hjJ3hIhP2hKPkL9KpVwL","pulse":"Ecr7D4tgJyZ1zABflEBt"};